module.exports = __webpack_public_path__ + "static/media/filter_empty.dad3db76.svg";